var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InsightsEventsTable',{staticClass:"activityLogTable",attrs:{"columns":_vm.columns,"isRefreshing":false,"loadingAdditionalData":false,"moreToLoad":false,"tableData":_vm.tableData}})
}
var staticRenderFns = []

export { render, staticRenderFns }